export const handleHttpError = async response => {
  if (!response.ok) {
    throw { status: response.status, ...(await response.json()) };
  }

  return response;
};
